import { Component, inject, Input, OnDestroy, OnChanges, SimpleChanges, ChangeDetectorRef, NgZone } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ApexAxisChartSeries, NgApexchartsModule } from 'ng-apexcharts';
import { CspNonceService } from '../shared/service/csp-nonce.service';
import { BaseComponent } from '../base/components/base.component';
import { ProductService } from '../shared/service/product.service';
import { ChartOptions } from '../shared/models/nox-chart';
import { LargeScaleTodayGenerationResponse } from '../shared/models/large-scale-today-generation';
import {Subject } from 'rxjs';

@Component({
    selector: 'app-large-scale-today-generation',
    imports: [TranslateModule, NgApexchartsModule],
    templateUrl: './large-scale-today-generation.component.html',
    styleUrl: './large-scale-today-generation.component.scss'
})
export class LargeScaleTodayGenerationComponent extends BaseComponent implements OnDestroy, OnChanges

 {
  @Input() plantID!: string;
  productService = inject(ProductService)
  cdr = inject(ChangeDetectorRef)
  ngZone = inject(NgZone)

  series: ApexAxisChartSeries = [];
  readonly destroy$ = new Subject<void>();
  showChart = false;
  constructor(private readonly cspNonceService: CspNonceService) {
    super();
  }
  chartOptions: Partial<ChartOptions> = {
    legend: { show: false }
  };


  getTodayGeneration(): void {
    this.productService
      .getTodayGenerationData(this.plantID)
      .subscribe({
        next: (response: LargeScaleTodayGenerationResponse) => {
          const data = response?.data?.inverterGenerationData;
          if (!data || !Array.isArray(data) || data.length === 0) {
            return;
          }
          this.series = [
            {
              name: 'Energy Generation',
              data: data.map(item => ({
                x: item.inverterName,
                y: item.energyGeneration
              }))
            }
          ];

          this.plotLargeScaleTodayGenerationGraph();
          this.showChart = true;
          this.cdr.detectChanges();
        }
        ,
        error: err => {
          this.ngZone.run(() => {
            this.logger.error(err);
          });
        }
      });
  }

  plotLargeScaleTodayGenerationGraph(): void {
    const nonce = this.cspNonceService.getNonce() ?? undefined;

    this.chartOptions = {
      series: this.series,
      chart: {
        type: 'bar',
        height: '324',
        nonce: nonce,
        toolbar: {
          show: true
        },
        zoom: {
          enabled: true
        },
        parentHeightOffset: 0,
        redrawOnParentResize: true,
        redrawOnWindowResize: true

      },
      grid: {
        padding: { bottom: 5 },
        borderColor: '#2E3440'
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '22%',
          borderRadius: 3,
          borderRadiusApplication: 'end'
        }
      },
      xaxis: {
        type: 'category',
        labels: {
          style: {
            colors: '#94989E',
            fontSize: '12px',
            fontWeight: 500
          }
        },
        title: {
          text: 'Inverters',
          style: {
            color: '#FFFFFF',
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        
        title: {
          text: 'Energy Generation (kWh)',
          style: {
            color: '#FFFFFF',
            fontSize: '12px'
          },
           
        },
         decimalsInFloat: 0,
        labels: {
          style: {
            colors: '#94989E',
            fontSize: '12px'
          }
        }
      },
      tooltip: {
        y: {
          formatter: (value: number) => `${value} kWh`
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      }
    };
  }
  formatInverterName(value: string): string {
    if (!value) return '';

    return value
      .replaceAll('_', ' ')
      .replaceAll(/([a-zA-Z])(\d)/g, '$1 $2');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['plantID'] && this.plantID) {
      this.getTodayGeneration();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
